import { render, staticRenderFns } from "./TableSearch.vue?vue&type=template&id=06844b74&scoped=true&"
import script from "./TableSearch.vue?vue&type=script&lang=js&"
export * from "./TableSearch.vue?vue&type=script&lang=js&"
import style0 from "./TableSearch.vue?vue&type=style&index=0&id=06844b74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06844b74",
  null
  
)

export default component.exports